/**
 * `Sort.svg` stays on its own glyph under the visual refresh (HNS-262), and it is the most
 * structurally stuck of the lot: it is a 10x16 pair of stacked triangles whose two paths
 * `MuiTableSortLabel` recolours INDIVIDUALLY — `& path` and `& path:first-of-type` — to encode which
 * way the column is sorted. `SortAscending`/`SortDescending` are single-direction glyphs with a
 * different path count, so swapping would silently break the direction cue rather than just look
 * different.
 */
import { createSvgIcon } from 'common/theme/utils';

import Sort from './Sort.svg?react';

export const SortIcon = createSvgIcon(Sort, 'Sort');
